$(document).ready(function(){
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
     //>=, not <=
//     if (scroll >= 100) {
//         //clearHeader, not clearheader - caps H
//         $("nav.header__inline-menu").addClass("scrolled-inactive");
//     }
// if (scroll <= 100) {
//         //clearHeader, not clearheader - caps H
//         $("nav.header__inline-menu").removeClass("scrolled-inactive");
//     }
  if(scroll >= 500){
    $('.cstm-scroll-top-btn').addClass('active');
  }
  if(scroll <= 500){
    $('.cstm-scroll-top-btn').removeClass('active');
  }
});
$('.cstm-scroll-top-btn').on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});
$('.banner-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay:true,
  autoplaySpeed:2500,
  arrows:true,
  speed:800,
  pauseOnHover:false,
  pauseOnFocus:false,
  prevArrow:'<button class="back-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
  nextArrow:'<button class="next-arrow"><i class="fa-solid fa-chevron-right"></i></button>',
  responsive: [
    {
      breakpoint: 481,
      settings: {
        arrows:false,
        dots:true
      }
    }
  ]
});
$('.offers-slider').slick({
  infinite: true,
  autoplay:true,
  speed:10000,
  autoplaySpeed: 0,
  slidesToShow: 2,
  slidesToScroll: 1,
  centerMode:false,
  swipe:true,
  arrows:false,
  cssEase: 'linear',
    responsive: [
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
  $('.as-seen-on-slider').slick({
  infinite: true,
  autoplay:true,
  speed:10000,
  autoplaySpeed: 0,
  slidesToShow: 5,
  slidesToScroll: 1,
  centerMode:false,
  swipe:true,
  arrows:false,
  cssEase: 'linear',
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 2
      }
    }
  ]
});
  $('.new-featured-collection-slider').slick({
  dots: false,
  arrows:true,
  prevArrow:'<button class="back-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
  nextArrow:'<button class="next-arrow"><i class="fa-solid fa-chevron-right"></i></button>',
  infinite: true,
  speed: 400,
  autoplay:true,
  autoplaySpeed:2500,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1370,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});
//   setTimeout(function(){
// $('body').removeClass('loader-visible');
// $('.gkw-loader-logo').hide();
// },2000);

   $(document).ready(function () {
        // Find the image in HTML1
        var image = $(".gkw-product-desc img");

        // Append the image to HTML2
        $(".gkw-product-spec").append(image.clone());
    });
  $('.gkw-product-desc-spec a.spec').click(function(){
$('.gkw-product-desc-spec-content .gkw-product-desc').hide();
$('.gkw-product-desc-spec-content .gkw-product-spec').show();
$(this).addClass('active');
$('.gkw-product-desc-spec a.desc').removeClass('active');
});
$('.gkw-product-desc-spec a.desc').click(function(){
$('.gkw-product-desc-spec-content .gkw-product-desc').show();
$('.gkw-product-desc-spec-content .gkw-product-spec').hide();
$(this).addClass('active');
$('.gkw-product-desc-spec a.spec').removeClass('active');
});

  $('.show-more-content p').click(function(){
$('.custom-widget').show();
$(this).hide();
});
  $('.show-less-content p').click(function(){
$('.custom-widget').hide();
$('.show-more-content p').show();
});

 var offset = 100;
$(".product__description_short a").click(function () {
    $("html, body").animate(
        { 
            scrollTop: $(".product-description-wrapper").offset().top - offset 
        }, 300);
});


$('.bar-icon.categories').click(function(){
$('header-drawer span').trigger('click');
});
  $('header-drawer span').click(function(){
    setTimeout(function(){
    if($('.menu-drawer-container').hasClass('menu-opening')){
        $('.floating-bar').hide();
    }else{
        $('.floating-bar').show();
    }
        },200);
});

});